module.exports = __webpack_public_path__ + "img/introduccion.e0b301cb.png";